export function getBadgeColor(cycles: number) {
  if (cycles < 80) {
    return 'green'
  } else if (cycles < 200) {
    return 'yellow'
  } else {
    return 'orange'
  }
}

export function getTimeAgoBadgeColor(date: Date){
  const daysAgo = Math.round((new Date().getTime() - date.getTime()) / (1000 * 60 * 60 * 24))

  if (daysAgo < 41){
    return "green"
  } else if(daysAgo < 81){
    return "yellow"
  } else {
    return "orange"
  }
}
